import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { DigitalSignatureServiceStore } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-service.store';
import { environment } from '@env/environment';

@Component({
  selector: 'app-third-party-saml-signature',
  templateUrl: './third-party-saml-signature.component.html',
  styleUrls: ['./third-party-saml-signature.component.scss'],
})
export class ThirdPartySamlSignatureComponent implements OnInit {
  public signatureURL: SafeResourceUrl = '';
  public url: string;
  public saml: string;
  public error: boolean = false;
  private readonly reqBody: FormData;
  ThirdPartySamlForm: FormGroup;
  public showIframe: boolean = false;
  @ViewChild('frame') public iframe: ElementRef;
  @ViewChild('formLogalty') postForm: ElementRef;

  constructor(
    private readonly _http: HttpClient,
    private readonly digitalSignatureServiceStore: DigitalSignatureServiceStore,
    private readonly loaderGenericService: LoaderGenericService,
    private readonly sanitizer: DomSanitizer,
    private readonly formBuilder: FormBuilder
  ) {
    this.ThirdPartySamlForm = this.formBuilder.group({
      saml: ['', [Validators.required]],
    });

    this.loaderGenericService.showSpinner();
    this.reqBody = new FormData();
    this.reqBody.append('saml_assertion', this.saml);
    this.url = environment.URL_LOGALTY_SIGNATURE;
    this.signatureURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  ngOnInit(): void {
    this.loaderGenericService.showSpinner();
    this.digitalSignatureServiceStore.samlthirdPartyObserver().subscribe((data: string) => {
      this.saml = data;
    });
  }

  ngAfterViewInit() {
    this.postForm.nativeElement.submit();
    setTimeout(() => {
      this.loaderGenericService.stopSpinner();
    }, 800);
  }

  submitForm($event: Event): boolean {
    $event.stopPropagation();
    this._http.post(this.url, this.reqBody);
    return true;
  }

  onLoad() {
    console.log('onLoad hecho');
  }

  ngOnDestroy() {
    this.digitalSignatureServiceStore.setSAMLthirdParty(null);
  }
}
